import { ApiPage } from "./ApiPage";
import withConnect from "./withConnect";

export default withConnect(ApiPage);
